var $style = document.querySelector('[data-filter-style]');
var $finishingField = document.querySelector('[data-filter-finishing]');
if ($style && $finishingField) {
    var styleItems = $style.dataset.filterStyle.split(',');
    var styleActive = function() {
        return $style.classList.toggle('dropdown_disabled', !styleItems.includes($finishingField.value));
    };
    styleActive();
    $finishingField.addEventListener('input', styleActive);
}
